import { gql } from '@apollo/client';

export const getEnvironmentSettingsDocument = gql`
    query getEnvironmentSettingsBySaasEnvironment($rentalAgreementId: Int) {
        getEnvironmentSettingsBySaasEnvironment(rentalAgreementId: $rentalAgreementId) {
            invoiceAsPaymentNotification
            messagingSettings {
                isMessagingEnabled
                displayName
            }
            tipsAndTricksEnabled
            emissionsEnabled
            agreementExtensionButtonEnabled
            agreementTerminationMinimumPriorToDays
            agreementTerminationButtonEnabled
            assistantSettings {
                enabled
                provider
            }
            pzuInsuranceEnabled
            showMetersInTenantApp
        }
    }
`;
